import type { ReactNode } from 'react';
import { BrandMark } from './BrandMark';
import { BrandPanelMedia } from './BrandPanelMedia';

interface AuthShellProps {
  children: ReactNode;
  /**
   * 'sidebar' (default): Login/Register/Authorize — panel hidden below 860px.
   * 'header': Landing only — panel collapses to a compact header above the
   * form below 860px instead of being hidden. Same content either way; only
   * the responsive layout differs (see DESIGN.md Layout).
   */
  brandLayout?: 'sidebar' | 'header';
}

/**
 * Split-screen layout shared by every auth page: a brand panel (ecosystem
 * media + tagline) on desktop, and the actual page content on the right. The
 * brand panel collapses away below 860px on Login/Register/Authorize — the
 * form is what matters on mobile — or becomes a compact header on Landing.
 */
export function AuthShell({ children, brandLayout = 'sidebar' }: AuthShellProps) {
  return (
    <div className="auth-shell">
      <div
        className={`auth-shell__brand${brandLayout === 'header' ? ' auth-shell__brand--header' : ''}`}
      >
        <div className="auth-shell__wordmark">
          <BrandMark />
          SateLab
        </div>
        <div className="auth-shell__art">
          <BrandPanelMedia />
        </div>
        <div className="auth-shell__copy">
          <p className="auth-shell__headline">Un acceso. Todo el ecosistema.</p>
          <p className="auth-shell__subhead">
            La misma cuenta para Academy, Paracaídas y el resto de plataformas
            SateLab — inicia sesión una vez y continúa donde quieras.
          </p>
        </div>
      </div>
      <div className="auth-shell__panel">{children}</div>
    </div>
  );
}
